import { get, post, put, remove } from '@/helpers/http';

export function fetchQuestions(pagination = {}) {
  return get('/questions', { ...pagination });
}

export function fetchQuestionsAnalytics(payload) {
  return get('/analytics/questions', payload);
}

export function fetchUserQuestions(id, pagination = {}) {
  return get('/user/questions', { user_id: id, ...pagination });
}

export function fetchTagQuestions(id, pagination = {}) {
  return get('/list/tag/questions', { tag_id: id, ...pagination });
}

export function getDepartmentQuestions(departmentId) {
  return get(`/department/questions/${departmentId}`);
}

export function getQuestion(questionId) {
  return get(`/questions/${questionId}`);
}

export function getAnswer(answerId) {
  return get(`/answers/${answerId}`);
}

export function getAnswers(questionId, pagination = {}) {
  return get(`/answers/question/${questionId}`, { ...pagination });
}

export function searchQuestions(searchTerm, pagination = {}) {
  return post('/search/questions', { search: searchTerm, ...pagination });
}

export function createQuestion(question) {
  return post('/questions', { ...question });
}

export function updateQuestion(question) {
  return put(`/questions/${question.id}`, question);
}

export function markAsAnsweredQuestion(question) {
  return put(`/questions/markAsAnswered/${question.id}`, { answered: question.answered });
}

export function removeQuestion(id) {
  return remove(`/questions/${id}`);
}
